import { datetime } from "../../utils";
import I18n from "../../I18n";

const renderResult = (value) => {
    switch (parseInt(value)) {
        case 0:
            return {
                value: "NOT_EXECUTED",
                label: I18n.translate`Not Executed`,
                aligment: "center",
                severity: 1,
                family: "warning",
                color: "main",
            };
        case 1:
            return {
                value: "EXECUTED_WITH_FINDINGS",
                label: I18n.translate`Executed with Findings`,
                aligment: "center",
                severity: 2,
                family: "error",
                color: "main",
            };
        case 2:
            return {
                value: "EXECUTED_SUCCESSFULLY",
                label: I18n.translate`Executed Successfully`,
                aligment: "center",
                severity: 0,
                family: "success",
                color: "main",
            };
        case 3:
            return {
                value: "WAITING_FOR_DATA",
                label: I18n.translate`Waiting For Data`,
                aligment: "center",
            };
        case 4:
            return {
                value: "DATA_NOT_RECEIVED",
                label: I18n.translate`Data Not Received`,
                aligment: "center",
            };
        case 5:
            return { value: "NEW", label: I18n.translate`New Execution`, aligment: "center" };
        case 6:
            return {
                value: "IN_PROGRESS",
                label: I18n.translate`In Progress`,
                aligment: "center",
            };
        default:
            return { value: "", label: "", aligment: "center" };
    }
};

const mapCard = (json) => {
    const { ruleIdentifier, result, createdAt, description, dataFileName } = json;
    return [
        [{ labels: ["rule"], value: ruleIdentifier, type: "string", basis: "10%", flex: 1 }],
        [{ labels: ["title"], value: description, type: "string", basis: "50%", flex: 1 }],
        [{ labels: ["file"], value: dataFileName, type: "string", flex: 1 }],
        [
            {
                labels: ["status"],
                value: renderResult(result),
                type: "status",
            },
        ],
        [{ labels: ["date"], value: datetime(createdAt), type: "date", flex: 1 }],
    ];
};

const mapper = (json, card) => {
    return {
        ...json,
        name: json.ruleIdentifier,
        shortName: json.ruleIdentifier,
        isRuleProcessing: json.isRuleProcessing,
        card: card ? mapCard(json) : [],
    };
};

const header = [
    {
        label: ["Rule"],
        align: "left",
        columnName: "rule_identifier",
        //TODO check with Vera if all columns are sortable
        sortable: true,
        basis: "10%",
        flex: 1,
        type: "string",
    },
    { label: ["Title"], align: "left", basis: "49.3%", flex: 1, type: "string" },
    { label: ["File"], align: "left", flex: 1, type: "string" },
    {
        label: ["Status"],
        align: "left",
        columnName: "result",
        sortable: true,
        flex: 1,
        type: "status",
    },
    {
        label: ["End Date"],
        align: "right",
        columnName: "created_at",
        sortable: true,
        flex: 1,
        type: "string",
    },
];

const ncAuditexecutionsummaryMapper = {
    map: mapper,
    header,
    showCheckbox: true,
};

export default ncAuditexecutionsummaryMapper;
